import React from 'react';
import { Shield, CheckCircle, Star, MapPin, Globe, Award } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { useLanguage } from '@/contexts/LanguageContext';
import { translations } from '@/utils/translations';

const TrustBadges = () => {
  const { currentLanguage } = useLanguage();
  const t = translations[currentLanguage];

  const trustBadges = [
    {
      icon: Shield,
      label: {
        de: "GDPR/FADP Konform",
        en: "GDPR/FADP Compliant",
        fr: "Conforme RGPD/LPD",
        it: "Conforme GDPR/LPD"
      },
      color: "text-green-500"
    },
    {
      icon: MapPin,
      label: {
        de: "local.ch Verifiziert",
        en: "local.ch Verified",
        fr: "Vérifié local.ch",
        it: "Verificato local.ch"
      },
      color: "text-blue-500"
    },
    {
      icon: Globe,
      label: {
        de: "Swiss Hosting",
        en: "Swiss Hosting",
        fr: "Hébergement Suisse",
        it: "Hosting Svizzero"
      },
      color: "text-red-500"
    },
    {
      icon: Star,
      label: {
        de: "4.9★ Google Reviews",
        en: "4.9★ Google Reviews",
        fr: "4.9★ Avis Google",
        it: "4.9★ Recensioni Google"
      },
      color: "text-yellow-500"
    },
    {
      icon: CheckCircle,
      label: {
        de: "ISO 27001 Partner",
        en: "ISO 27001 Partner",
        fr: "Partenaire ISO 27001",
        it: "Partner ISO 27001"
      },
      color: "text-purple-500"
    },
    {
      icon: Award,
      label: {
        de: "Schweizer KMU",
        en: "Swiss SME",
        fr: "PME Suisse",
        it: "PMI Svizzera"
      },
      color: "text-primary"
    }
  ];

  return (
    <div className="flex flex-wrap justify-center gap-3 md:gap-4">
      {trustBadges.map((badge, index) => {
        const Icon = badge.icon;
        return (
          <Badge
            key={index}
            variant="outline"
            className="flex items-center gap-2 px-3 py-2 bg-card/50 backdrop-blur-sm border-border/50 hover:border-primary/30 transition-colors"
          >
            <Icon size={16} className={badge.color} />
            <span className="text-xs font-medium text-foreground/90">
              {badge.label[currentLanguage as keyof typeof badge.label]}
            </span>
          </Badge>
        );
      })}
    </div>
  );
};

export default TrustBadges;